import { render, staticRenderFns } from "./EmployeesPersonalTaxFileImport.vue?vue&type=template&id=5179335a"
import script from "./EmployeesPersonalTaxFileImport.vue?vue&type=script&lang=js"
export * from "./EmployeesPersonalTaxFileImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports